import { useFormContext } from 'react-hook-form';
import { RegistrationField } from '../../../../interfaces/interfaces';
import { VyFileField } from '../../../common/VyFileField';
import { RegistrationFormFieldProps } from '.';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'next-i18next';

interface RegistrationFileFieldProps extends Omit<RegistrationFormFieldProps, 'watch' | 'updateRequiredFieldIds' | 'requiredFieldIds'> {
  isRequired: (field: RegistrationField) => boolean;
  uploadMultiple?: boolean;
  onBlur?: (key: string, value: string) => void;
}

const RegistrationFileField = ({
  uploadMultiple,
  field,
  disabled,
  fieldsBorderColor,
  color,
  isRequired,
  showFieldLabel,
  onBlur,
  defaultValue,
}: RegistrationFileFieldProps) => {
  const [currentAttachments, setCurrentAttachments] = useState<string[]>();

  const {
    setValue,
    formState: { errors },
    register,
    clearErrors,
    watch,
  } = useFormContext();
  const { t } = useTranslation();

  const handleChange = (fileIds: string[]) => {
    setCurrentAttachments(fileIds);
    if (onBlur) setTimeout(() => onBlur(field._id, fileIds.join(',')), 0);
  };

  useEffect(() => {
    if (currentAttachments) {
      clearErrors(field._id);
    }
    setValue(field._id, currentAttachments ? (currentAttachments.length === 1 ? currentAttachments[0] : currentAttachments.join(',')) : '');
  }, [currentAttachments]);

  useEffect(() => {
    if (defaultValue) setCurrentAttachments(defaultValue.split(','));
  }, [defaultValue]);

  return (
    <>
      {showFieldLabel && <span className="text-current">{field.label}</span>}
      <VyFileField
        onChange={handleChange}
        currentAttachments={currentAttachments}
        compact
        isSignupUpload
        uploadMultiple={uploadMultiple}
        borderColor={fieldsBorderColor}
        textColor={color}
        error={errors[field._id]?.message?.toString()}
        disabled={disabled}
      />
      <input
        type="text"
        {...register(field._id, { required: { value: isRequired(field), message: t('form:fieldrequired') } })}
        hidden
        value={watch(field._id)}
      />
    </>
  );
};
export default RegistrationFileField;
